import * as React from 'react';

import styles from './joined-domains.module.css';

type Props = {
    domains: string[];
};

export function JoinedDomains(props: Props) {
    const {domains} = props;

    if (domains.length === 0) return '';

    const domainElements = domains.map((domain) => (
        <span key={domain} className={styles.domain}>{`@${domain}`}</span>
    ));
    if (domainElements.length === 1) return domainElements[0];

    if (domainElements.length === 2) {
        return (
            <React.Fragment>
                {domainElements[0]} or {domainElements[1]}
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            {domainElements.reduce(
                (accum, elem, index) =>
                    // @ts-expect-error
                    accum === null
                        ? [elem]
                        : [...accum, index === domainElements.length - 1 ? ', or ' : ', ', elem],
                null
            )}
        </React.Fragment>
    );
}
